import React from 'react';
import styled from 'styled-components';
import { Search } from '@finect/tabular-icons/search';
import { PlusCircle } from '@finect/tabular-icons/plusCircle';
import { Paragraph } from '@finect/tabular-core/Paragraph';
export var EmptyContentInner = styled.div.withConfig({
  displayName: "EmptyResults__EmptyContentInner",
  componentId: "sc-1ugsgoe-0"
})(["color:", ";text-align:center;svg{margin:42px auto 18px;}p{margin:0 auto;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.fontL;
});
export var EmptyResults = function EmptyResults() {
  return React.createElement(EmptyContentInner, null, React.createElement(Search, {
    size: "56"
  }), React.createElement(Paragraph, null, "\xA1Vaya! No hemos encontrado resultados para tu b\xFAsqueda."));
};
export var EmptyResultsFetching = function EmptyResultsFetching() {
  return React.createElement(EmptyContentInner, null, React.createElement(Search, {
    size: "56"
  }), React.createElement(Paragraph, null, "Buscando..."));
};
export var WithFundPlaceholder = function WithFundPlaceholder() {
  return React.createElement(EmptyContentInner, null, React.createElement(PlusCircle, {
    size: "42px"
  }), React.createElement(Paragraph, null, "A\xF1ade fondos a la lista para empezar a comparar"));
};